import type { SocialImageData } from '@/content/types';

export default function SocialImage(props: SocialImageData) {
  const reverse = props.imagePosition === 'left';
  return (
    <section className="section-padding">
      <div className={reverse ? 'container split-2col reverse' : 'container split-2col'}>
        <div>
          {props.eyebrow && (
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '6px 12px', borderRadius: 999, background: '#fff', fontSize: 12, fontWeight: 600, marginBottom: 24 }}>
              ● {props.eyebrow}
            </div>
          )}
          <h2 className="h-section">{props.title}</h2>
          <p style={{ marginTop: 24, color: 'var(--color-muted)', fontSize: 16 }}>{props.body}</p>
          <a href={props.cta.href} className="btn-primary" style={{ marginTop: 32 }}>
            {props.cta.label} →
          </a>
        </div>
        <div>
          <img src={props.image.src} alt={props.image.alt} width={props.image.width} height={props.image.height} loading="lazy" decoding="async" style={{ borderRadius: 24, width: '100%', height: 'auto' }} />
        </div>
      </div>
    </section>
  );
}
